export default function DriverShipment() {

  return (
      <p>مدیریت حمل و نقل</p>
  );
};